import { ControllerProps } from "@/components/inspector/controller/Controllers";
import { Tab } from "@/components/inspector/tab/Tab";
import { TabName } from "@/components/inspector/tab/InspectorTabs";
import { MaterialDto } from "@/types/data-types";

export interface InspectorMaterialTabProps {
  open: boolean;
  onClick: () => void;
  currentMaterial: MaterialDto;
  setCurrentMaterial: React.Dispatch<React.SetStateAction<MaterialDto>>;
}

export const InspectorMaterialTab = ({
  open,
  onClick,
  currentMaterial,
  setCurrentMaterial,
}: InspectorMaterialTabProps) => {
  const materialControllerProps: ControllerProps[] = [
    {
      type: "colour",
      label: "Color",
      value: currentMaterial.color,
      setValue: (value) =>
        setCurrentMaterial((prevMaterial) => ({
          ...prevMaterial,
          color: value,
        })),
    },
    {
      type: "slider",
      label: "Opacity",
      value: currentMaterial.opacity,
      setValue: (value) =>
        setCurrentMaterial((prevMaterial) => ({
          ...prevMaterial,
          opacity: value,
        })),
      min: 0,
      max: 1,
      step: 0.1,
    },
    {
      type: "slider",
      label: "Roughness",
      value: currentMaterial.roughness,
      setValue: (value) =>
        setCurrentMaterial((prevMaterial) => ({
          ...prevMaterial,
          roughness: value,
        })),
      min: 0,
      max: 1,
      step: 0.1,
    },
    {
      type: "slider",
      label: "Metalness",
      value: currentMaterial.metalness,
      setValue: (value) =>
        setCurrentMaterial((prevMaterial) => ({
          ...prevMaterial,
          metalness: value,
        })),
      min: 0,
      max: 1,
      step: 0.1,
    },
    {
      type: "colour",
      label: "Emissive",
      value: currentMaterial.emissive,
      setValue: (value) =>
        setCurrentMaterial((prevMaterial) => ({
          ...prevMaterial,
          emissive: value,
        })),
    },
    {
      type: "select",
      label: "Side",
      value: String(currentMaterial.side),
      setValue: (value) =>
        setCurrentMaterial((prevMaterial) => ({
          ...prevMaterial,
          side: Number(value),
        })),
      options: [
        {
          label: "Front",
          value: "0",
        },
        { label: "Back", value: "1" },
        {
          label: "Double",
          value: "2",
        },
      ],
    },
  ];

  return (
    <Tab
      label={TabName.Material}
      layout={"flex"}
      items={materialControllerProps}
      open={open}
      onClick={onClick}
    />
  );
};
